export default __webpack_public_path__ + "static/factorio-logo-53bd58a6dd597cdb401deb84c67f0da2.png";